import { useTranslation } from 'react-i18next';
import { TreeFilterBar } from '@/shared/ui';
import type { TransportTypeFilter } from '@/api/generated/schemas';

interface ColumbusTreeFilterBarProps {
  transportType: TransportTypeFilter | null;
  includeHistory: boolean;
  onTransportTypeChange: (value: TransportTypeFilter | null) => void;
  onIncludeHistoryChange: (value: boolean) => void;
  className?: string;
}

/**
 * Lišta filtrů stromu Columbus plánovače — tenký wrapper nad sdílenou `TreeFilterBar`
 * (PHX-TREE-01 § 2), který jen dodává columbus lokalizaci. Hodnoty `TransportTypeFilter`
 * (Air/Bus) jsou přiřaditelné na sdílený `TreeTransportFilter`.
 */
export function ColumbusTreeFilterBar({
  transportType,
  includeHistory,
  onTransportTypeChange,
  onIncludeHistoryChange,
  className,
}: ColumbusTreeFilterBarProps) {
  const { t } = useTranslation('columbus-planner');

  return (
    <TreeFilterBar
      transportType={transportType}
      includeHistory={includeHistory}
      onTransportTypeChange={(value) => onTransportTypeChange(value as TransportTypeFilter | null)}
      onIncludeHistoryChange={onIncludeHistoryChange}
      className={className}
      labels={{
        toolbar: t('filterBar.label'),
        transport: t('filterBar.transportType.label'),
        air: t('filterBar.transportType.air'),
        bus: t('filterBar.transportType.bus'),
        history: t('filterBar.history.label'),
        historyShownTitle: t('filterBar.history.shownTitle'),
        historyHiddenTitle: t('filterBar.history.hiddenTitle'),
      }}
    />
  );
}
